module.exports = __webpack_public_path__ + "img/buissonniere-e-commerce-success-story.fdb932d6.jpg";